import React, { useEffect, useState } from 'react';

import marketplaceModule from '../../api/modules/marketplace.module';
import { mediaUrl } from '../../utils/common';
import { SetsView } from './SetsPage.view';

/**
 * Sets, the container. Owns the one fetch and nothing else.
 *
 * Everything visual lives in `SetsPage.view.jsx`, which is pure, so the state
 * explorer can mount the real screen without the API running. See
 * `design-system/explorer/registry.js` for that convention.
 *
 * The fetch, its success/failure branches and the copy of every message are
 * unchanged from the pre-conversion page. What went is the navigation: the tile
 * used to be a `<div onClick={() => navigate(...)}>`, so `useNavigate` is no
 * longer needed here and the tiles are real links.
 */
export default function SetsPage() {
  const [tcgCategories, setTcgCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchTCGCategories = async () => {
      try {
        setLoading(true);
        const response = await marketplaceModule.getTCGCategories();

        if (response.success) {
          setTcgCategories(response.data || []);
        } else {
          setError(response.message || 'Failed to load TCG categories');
        }
      } catch (err) {
        setError('An error occurred while loading TCG categories');
        console.error('Error fetching TCG categories:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchTCGCategories();
  }, []);

  return (
    <SetsView
      categories={tcgCategories}
      loading={loading}
      error={error}
      mediaUrl={mediaUrl}
    />
  );
}
